
export class Question {

	code: number;
	description: string;
	answer: any;
	type?: number;
	integers?: number;
	decimals?: number;
	size?: number;
	mask?: Array<any> = [];

	constructor() {}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/models/question.ts